import { render } from "./DuplicateBulkCampaignAction.vue?vue&type=template&id=6e952238"
import script from "./DuplicateBulkCampaignAction.vue?vue&type=script&lang=ts"
export * from "./DuplicateBulkCampaignAction.vue?vue&type=script&lang=ts"
script.render = render

export default script